import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

// Note: intentionally no <React.StrictMode>. Its double mount/unmount in dev
// drops R3F useFrame subscriptions under frameloop="demand", which stops the
// markers' back-face occlusion from updating.
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
